export default "__VITE_ASSET__DWBQUgwK__"